export const discordInviteUrl = "https://discord.gg/pHfjB8M5W3";
export const facebookUrl = "https://www.facebook.com/BuddyTape-102411322025535";
export const instagramUrl = "https://www.instagram.com/buddytape.app/";

export {};
